import httpClient from "@/plugins/axios";
import resource_types from "@/@core/utils/resource_types";

export const getResources = async (page, pageSize = 10) => {
    const response = await httpClient.get(`/v1/resources/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}

export const download = async (id) => {
    const response = await httpClient.get(`/v1/resources/${id}/view/?admin_view=1`,
        {
            responseType: 'blob',
        });
    return response;
}

export const getResource = async (id) => {
    const response = await httpClient.get(`/v1/resources/${id}/?admin_view=1&translations=1`);
    return response;
}

export const saveResource = async (resource) => {
    if (resource.id) {
        return await updateResource(resource);
    }
    else {
        return await insertResource(resource);
    }
};

const insertResource = async (resource) => {
    const formData = getFormData(resource);

    const response = await httpClient.post('/v1/resources/?admin_view=1', formData);
    return response;
}

const updateResource = async (resource) => {
    const formData = getFormData(resource);

    const response = await httpClient.put(`/v1/resources/${resource.id}/?admin_view=1`, formData);
    return response;
}

export const deleteResource = async (id) => {
    const response = await httpClient.delete(`/v1/resources/${id}/?admin_view=1`);
    return response;
}

const getFormData = (resource) => {
    const formData = new FormData()
    formData.append('id', resource.id)
    formData.append('group', resource.group)
    formData.append('resource_type', resource.resource_type)
    formData.append('published', resource.published)
    if (
        resource.resource_type === resource_types.document.value
    ) {
        if (resource.file) {
            formData.append('file', resource.file)
        }
        formData.append('filename', resource.filename)
        formData.append('link', '')
    } else {
        formData.append('link', resource.link)
        formData.append('filename', '')
    }

    let translations = {}
    Object.keys(resource.translations).forEach((lang) => {
        if (resource.translations[lang].title) {
            translations[lang] = {
                title: resource.translations[lang].title,
                description: resource.translations[lang].description,
            }
        }
    })
    formData.append('translations', JSON.stringify(translations))

    return formData;
}